import React, { useEffect, useState } from "react";
import NextStepsSection from "@/pages/deals/components/DealNextSteps/NextStepsSection";
import AddNewStepSection from "@/pages/deals/components/DealNextSteps/AddNewStepSection";
import { useDealNextSteps } from "@/pages/deals/hooks";

interface DealNextStepsProps {
  dealId: string;
  hasNextSteps: boolean;
}

const DealNextSteps: React.FC<DealNextStepsProps> = ({
  dealId,
  hasNextSteps
}) => {
  const [hasNextStepsInternal, setHasNextStepsInternal] =
    useState(hasNextSteps);
  const [isExpanded, setIsExpanded] = useState(false);

  const {
    data: nextStepsData,
    refetch,
    isLoading
  } = useDealNextSteps(dealId, isExpanded);

  const allNextSteps = nextStepsData?.nextSteps || [];

  useEffect(() => {
    setHasNextStepsInternal(hasNextSteps);
  }, [hasNextSteps]);

  return hasNextStepsInternal ? (
    <NextStepsSection
      dealId={dealId}
      allNextSteps={allNextSteps}
      isLoading={isLoading}
      isExpanded={isExpanded}
      setIsExpanded={setIsExpanded}
      setHasNextStepsInternal={setHasNextStepsInternal}
      refetch={refetch}
    />
  ) : (
    <AddNewStepSection
      dealId={dealId}
      setHasNextStepsInternal={setHasNextStepsInternal}
      setIsExpanded={setIsExpanded}
      refetch={refetch}
    />
  );
};

export default DealNextSteps;
